// Landing pages (components/hub). Neutral Latin American Spanish, Brazilian
// Portuguese; wording follows what people search (config/localeHubs.ts).
export const hub = {
  en: {
    "hub.views.count": "10 billion+",
    "hub.views.on": "views on",
    "hub.badge.covers": "10M+ covers made",
    "hub.badge.quality": "Studio-quality output",
    "hub.badge.youtube": "As seen on YouTube",
    "hub.trending": "Trending",
    "hub.popular": "Popular voices right now",
    "hub.browseAll": "Browse all",
    "hub.byCategory": "Browse voices by category",
    "hub.aiVoices": "AI voices",
    "hub.howItWorks": "How it works",
    "hub.faq": "Frequently asked questions",
    "hub.keepExploring": "Keep exploring",
    "hub.moreWays": "More ways to create with Jammable.",
    "hub.home": "Home",

    "widget.title": "Pick a voice to start",
    "widget.search": "Search voices",
    "widget.clear": "Clear search",
    "widget.matching": 'Voices matching "{q}"',
    "widget.popular": "Popular right now",
    "widget.noMatch": "No voices match that search.",
    "widget.searchAny": "Search for any voice above.",
    "widget.coverWith": "Make a cover with {name}",
    "widget.start": "Start with any voice",
    "widget.rights":
      "Next you add your audio. Only upload audio you have the rights to use.",

    // Shown in the language it offers, on pages that have a version in it.
    "lang.viewThisPage": "View this page in English",
    "lang.dismiss": "Dismiss",
  },
};
